function pluralize<T>(word: string, count: number) {
  return count > 1 ? `${word}s` : word
}

export { pluralize }
